import { render, staticRenderFns } from "./TaskComments.vue?vue&type=template&id=21d26d2e"
import script from "./TaskComments.vue?vue&type=script&lang=js"
export * from "./TaskComments.vue?vue&type=script&lang=js"
import style0 from "./TaskComments.vue?vue&type=style&index=0&id=21d26d2e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports